import { Disposable } from '../DisposableContainer/DisposableContainer';
import { TimingUtils } from '../TimingUtils/TimingUtils';

export class TaskQueue {
  private static defaultTaskContext = Symbol('defaultTaskContext');
  private static lastTaskId: number = 0;
  private static tasks: Array<Task> = [];
  private static timeoutDisposable: Disposable | null = null;

  private constructor() {}

  public static queueTask(worker: () => void): Disposable {
    return this.queueTaskWithContext(this.defaultTaskContext, worker);
  }

  public static queueUniqueTask(
    context: unknown,
    worker: () => void
  ): Disposable {
    this.removeTasksByContext(context);
    return this.queueTaskWithContext(context, worker);
  }

  public static removeTasksByContext(context: unknown): void {
    this.removeTasks((task) => task.context === context);
  }

  public static flush(): void {
    // eslint-disable-next-line no-constant-condition, @typescript-eslint/no-unnecessary-condition
    while (true) {
      const task = this.tasks.shift();
      if (!task) {
        break;
      }

      task.worker();
    }
  }

  private static queueTaskWithContext(
    context: unknown,
    worker: () => void
  ): Disposable {
    const id = ++this.lastTaskId;
    this.tasks.push({
      id,
      worker,
      context
    });

    this.startTimeout();

    return {
      dispose: () => {
        this.removeTasks((task) => task.id === id);
      }
    };
  }

  private static startTimeout(): void {
    if (this.timeoutDisposable) {
      return;
    }

    this.timeoutDisposable = TimingUtils.setTimeout(() => {
      this.timeoutDisposable = null;
      this.flush();
    }, 0);
  }

  private static removeTasks(shouldRemoveTask: (task: Task) => boolean): void {
    for (let i = this.tasks.length - 1; i >= 0; i--) {
      if (shouldRemoveTask(this.tasks[i] as Task)) {
        this.tasks.splice(i, 1);
      }
    }
  }
}

type Task = {
  id: number;
  context: unknown;
  worker: () => void;
};
